import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const PriceGeneralField = ({ required, setValidate, setValueForm, forciblyValue, onBlurMy }) => {

	const [value, setValue] = useState('')

  return (
    <TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Загальна вартість'} 
        placeholder={'Введіть цифру'}
        validates={{
            isEmpty: true,
            isNumber: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
        onBlurMy={onBlurMy}
		
    />
  )
}

export default PriceGeneralField